import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const isRecommendationRecommendedProperty = (application: IRecommendedProperty | IRecommendedOffer): application is IRecommendedProperty => {
    return "offer" in application;
};
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const isRecommendationRecommendedProperty = (application: IRecommendedProperty | IRecommendedOffer): application is IRecommendedProperty => {
    return "offer" in application;
};
